export class OverviewApiError extends Error {
  constructor(
    message: string,
    public statusCode: number,
  ) {
    super(message);
    this.name = 'OverviewApiError';
  }
}

export const handleOverviewApiError = (response: Response) => {
  if (!response.ok) {
    throw new OverviewApiError(
      `Overview API error: ${response.statusText}`,
      response.status,
    );
  }
};
